import { SITE } from "@/config/site";

/**
 * Book cover component.
 * Renders the actual cover image if SITE.book.coverUrl is set,
 * otherwise renders an elegant styled placeholder that reads as a real book cover.
 */
export default function BookCover({ size = "md", className = "" }) {
  const b = SITE.book;
  const sizes = {
    sm: "w-24 sm:w-28",
    md: "w-40 sm:w-48",
    lg: "w-56 sm:w-64 md:w-72",
    xl: "w-72 sm:w-80 md:w-96",
  };
  const dims = sizes[size] || sizes.md;
  const hasImage = Boolean(b.coverUrl);
  const aspect = hasImage ? "" : "aspect-[2/3]";

  return (
    <div
      className={`relative ${dims} ${aspect} rounded-md overflow-hidden shadow-2xl ring-1 ring-black/5 ${className}`}
      data-testid="book-cover"
    >
      {hasImage ? (
        <img
          src={b.coverUrl}
          alt={`${b.title} — book cover`}
          className="block w-full h-auto"
        />
      ) : (
        <div
          className="h-full w-full flex flex-col justify-between p-5 sm:p-6 text-white"
          style={{
            background:
              "linear-gradient(160deg, #0e5a5f 0%, #0a3f43 55%, #06292c 100%)",
          }}
        >
          <div>
            <p className="text-[10px] sm:text-xs tracking-[0.25em] uppercase text-amber-200/90">
              A companion book
            </p>
            <div className="mt-2 h-0.5 w-8 bg-amber-300/80" />
          </div>
          <div>
            <h3
              className="font-heading text-xl sm:text-2xl md:text-3xl font-semibold leading-tight"
              style={{ color: "#f4e8c8" }}
            >
              {b.title}
            </h3>
            <p className="mt-2 text-[10px] sm:text-xs text-white/70 leading-snug italic">
              {b.subtitle}
            </p>
          </div>
          <div>
            <div className="h-0.5 w-8 bg-amber-300/80 mb-2" />
            <p className="text-[10px] sm:text-xs tracking-wider text-amber-100/90">
              {b.author}
            </p>
          </div>
        </div>
      )}
      {/* subtle spine highlight */}
      <div
        className="pointer-events-none absolute inset-y-0 left-0 w-1.5 bg-gradient-to-r from-black/25 via-black/5 to-transparent"
        aria-hidden="true"
      />
    </div>
  );
}
